import React from 'react'

import { Hidden } from '@material-ui/core'

const Mobile: React.FC = ({ children }) => {
  return <Hidden mdUp>{children}</Hidden>
}

export default Mobile
